import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { MainService } from './_base_services/main.service';
import { ErrorHandleService } from './_base_services/error-Handle.service';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from './toastr.service';
import { FirmaBilgileri } from '../_models/firmabilgileri';
import { isNullOrUndefined } from 'util';
declare var $:any;

@Injectable()
export class GlobalService extends MainService {
  
  firma;


  constructor(@Inject(PLATFORM_ID)  platformId: Object,http: HttpClient, errorHandleService: ErrorHandleService, private toastr: ToastrService) {
    super(platformId , http, errorHandleService);
  }

  getFirmaBilgileri(){
    console.log('firma' , this.firma)
    if (!isNullOrUndefined(this.firma)) { console.log('fonksss'); return this.firma }
   return new Promise((resolve) =>{
      this.GetID('/firmabilgileri/front',1).subscribe((resp:FirmaBilgileri)=>{
      console.log('resp' , resp)
      this.firma = resp;
      resolve(resp);
    })
   })
   
   // return 
  }
 
  
 
}

